import { render, staticRenderFns } from "./modalProcedimientoPorPrograma.vue?vue&type=template&id=1511a67e&scoped=true"
import script from "./modalProcedimientoPorPrograma.vue?vue&type=script&lang=js"
export * from "./modalProcedimientoPorPrograma.vue?vue&type=script&lang=js"
import style0 from "./modalProcedimientoPorPrograma.vue?vue&type=style&index=0&id=1511a67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511a67e",
  null
  
)

export default component.exports